(function() {
  'use strict';

  var drawerStateClass = 'bt-cart-drawer-open';
  var closeRequested = false;

  function isVisible(element) {
    var styles = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();

    return styles.display !== 'none' &&
      styles.visibility !== 'hidden' &&
      styles.opacity !== '0' &&
      rect.width > 0 &&
      rect.height > 0;
  }

  function isCartDrawerOpen() {
    var drawer = document.getElementById('CartDrawer');

    return document.documentElement.classList.contains('js-drawer-open') &&
      drawer &&
      drawer.classList.contains('drawer--is-open');
  }

  function closeKlaviyoModals() {
    if (closeRequested) {
      return;
    }

    document.querySelectorAll('[data-testid^="klaviyo-form-"], .klaviyo-form').forEach(function(form) {
      var dialog = form.closest('[role="dialog"]');
      var closeButton = dialog && dialog.querySelector('.klaviyo-close-form');

      if (dialog && closeButton && isVisible(dialog) && isVisible(closeButton)) {
        closeRequested = true;
        closeButton.click();
        window.setTimeout(function() {
          closeRequested = false;
        }, 1000);
      }
    });
  }

  function syncCartPopupState() {
    var drawerOpen = isCartDrawerOpen();

    document.documentElement.classList.toggle(drawerStateClass, drawerOpen);

    if (!drawerOpen) {
      return;
    }

    closeKlaviyoModals();

    // Klaviyo can leave its body scroll-lock class behind while its overlay
    // is being dismissed. The theme's cart drawer has its own scroll lock.
    document.body.classList.remove('klaviyo-prevent-body-scrolling');
  }

  function init() {
    document.addEventListener('drawerOpen', syncCartPopupState);
    document.addEventListener('drawerOpen.CartDrawer', syncCartPopupState);

    document.addEventListener('click', function(event) {
      if (event.target.closest && event.target.closest('.js-drawer-open-cart')) {
        window.requestAnimationFrame(syncCartPopupState);
      }
    }, true);

    syncCartPopupState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
